module.exports = __webpack_public_path__ + "static/media/Erin Cadwalader1_1669835332386.67eaab8a.jpg";